const drawRect = ({
  x = 0,
  y = 0,
  w = 20,
  h = 20,
  radius,
  strokeStyle,
  fillStyle,
  lineWidth = 2,
  lineDash,
  context,
}) => {
  let radiusConfig = { tl: 0, tr: 0, br: 0, bl: 0 }

  if (typeof radius === 'number') {
    radiusConfig = { tl: radius, tr: radius, br: radius, bl: radius }
  }

  context.beginPath()
  context.moveTo(x + radiusConfig.tl, y)
  context.lineTo(x + w - radiusConfig.tr, y)
  context.quadraticCurveTo(x + w, y, x + w, y + radiusConfig.tr)
  context.lineTo(x + w, y + h - radiusConfig.br)
  context.quadraticCurveTo(x + w, y + h, x + w - radiusConfig.br, y + h)
  context.lineTo(x + radiusConfig.bl, y + h)
  context.quadraticCurveTo(x, y + h, x, y + h - radiusConfig.bl)
  context.lineTo(x, y + radiusConfig.tl)
  context.quadraticCurveTo(x, y, x + radiusConfig.tl, y)
  context.closePath()

  if (fillStyle) {
    context.fillStyle = fillStyle
    context.fill()
  }

  if (strokeStyle) {
    lineDash && context.setLineDash(lineDash)
    context.strokeStyle = strokeStyle
    context.lineWidth = lineWidth
    context.stroke()
  }
}

export default drawRect
